"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _jsxFileName = "/builds/schumacherweb/devbridge/ui-shared/549481182/shared/src/theme/icons/files/scp-connect-logo.svg.js",
    _g,
    _defs;

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ReactComponent(props) {
  return React.createElement("svg", (0, _extends2["default"])({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: this
  }), _g || (_g = React.createElement("g", {
    clipPath: "url(#prefix__clip0_5538_35808)",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13
    },
    __self: this
  }, React.createElement("path", {
    d: "M25.82 40.18a21.17 21.17 0 01-3.938-24.435A18.241 18.241 0 003.872 43.63L1.79 51.232l7.61-2.09a18.24 18.24 0 0024.135-4.033 21.049 21.049 0 01-7.714-4.93z",
    fill: "#878787",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14
    },
    __self: this
  }), React.createElement("path", {
    d: "M53.66 12.34A18.238 18.238 0 1050.6 40.602l7.61 2.08-2.09-7.61a18.244 18.244 0 00-2.462-22.73zm-6.12 6.686l3.993 5.935h-7.04l-2.924-5.935h5.97zm-18.66 4.38l2.732-4.38h7.286L36.21 23.34l-7.33.067zm10.77 6.986l-.194-.441-2.724-6.29 2.715-4.383 3.032 5.93-2.828 5.184zM47.6 31.46h-6.067l2.963-5.895h7.043l-3.94 5.895z",
    fill: "#E87824",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18
    },
    __self: this
  }))), _defs || (_defs = React.createElement("defs", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23
    },
    __self: this
  }, React.createElement("clipPath", {
    id: "prefix__clip0_5538_35808",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24
    },
    __self: this
  }, React.createElement("path", {
    fill: "#fff",
    transform: "translate(1 7)",
    d: "M0 0h58v45.02H0z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25
    },
    __self: this
  })))));
}

var _default = ReactComponent;
exports["default"] = _default;